import React, { useState } from 'react'

import styled from 'styled-components'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'
import ComboBox from 'components/ComboBox'
import Modal from 'components/Modal'
import ModalButton from 'components/Modal/Button'

import { ButtonContainer } from 'styles/shared'

import { CONFIRMATION_DIALOG_MESSAGES } from 'helpers/confirmationDialogMessages'

const OPTIONS = ['', 'It\'s too expensive', 'The features aren\'t useful', 'Will try again later', 'Other']

type CancelSubscriptionProps = {
  closeCallback: () => void
  isVisible?: boolean
  reason?: string
  deviceId: string
  onCancelCallback: (updatedReason: string) => Promise<void>
}

const CancelSubscriptionModal = ({ closeCallback, isVisible = false, deviceId, reason = '', onCancelCallback }: CancelSubscriptionProps) => {
  const [currentReason, setCurrentReason] = useState(reason)
  const [deleteInProgress, setDeleteInProgress] = useState(false)
  const [showReasonError, setShowReasonError] = useState(false)

  const onBackButtonClicked = async () => {
    closeCallback()
  }

  const onInputChange = (reason: string) => {
    setCurrentReason(reason)
    if (reason) setShowReasonError(false)
  }

  const onCancelSubscriptionButtonClicked = async () => {
    if (!currentReason) {
      setShowReasonError(true)
      return
    }
    setDeleteInProgress(true)
    await onCancelCallback(currentReason)
    setDeleteInProgress(false)

    closeCallback()
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onCancelSubscriptionButtonClicked()
  }

  return (
    <Modal
      variant="sm"
      fullWidth
      title={CONFIRMATION_DIALOG_MESSAGES.CANCEL_HEHM_DEVICE.TITLE}
      isDisplayed={isVisible}
      closeCallback={() => closeCallback()}
    >
      <form onSubmit={handleSubmit}>
        <S.Description>Device ID: <b>{deviceId}</b></S.Description>
        <S.Description>{CONFIRMATION_DIALOG_MESSAGES.CANCEL_HEHM_DEVICE.DESCRIPTION}</S.Description>

        <ComboBox
          label="Reason *"
          value={currentReason}
          onBlur={(event) => { onInputChange(event.target.value) }}
          onSelectChange={(event) => { onInputChange(event.target.value) }}
          onInputChange={(event) => { onInputChange(event.target.value) }}
          options={OPTIONS}
          autoFocus
          errorMessage={showReasonError ? 'Reason is required' : ''}
        />

        <S.ButtonContainer>
          <Button decoration="secondary" styles={{ button: { marginRight: 15 } }} text="Back" onPress={onBackButtonClicked} />
          <ModalButton decoration="positive" text="Confirm" onPress={async () => await onCancelSubscriptionButtonClicked()} showSpinner={deleteInProgress} type="submit" />
        </S.ButtonContainer>
      </form>
    </Modal>
  )
}

const S = {
  ButtonContainer: styled(ButtonContainer)`
    margin-top: 0px;
    border-top: none;
  `,
  Description: styled.div`
    margin-bottom: 20px;
  `
}

export default CancelSubscriptionModal
